<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12JILTd/tc-custom/9781780105185.jpg?1702841330235" alt="This image is the cover for the book Beneath the Soil, A Suzie Fewings Genealogical Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beneath the Soil, A Suzie Fewings Genealogical Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>Family trees and family secrets embroil amateur sleuth Suzie Fewings in a murder mystery: “A good choice for genealogists and cozy lovers” (<i>Booklist</i>).</b><br/>  <br/> Genealogy-enthusiast Suzie Fewings and her family are on an ancestral-history trip to Saddlers Wood Farm when they hear a gunshot ringing out. The local farmer and his wife, Philip and Eileen, seem strangely agitated and upset, and direct them to a ruined cottage in the wood . . . where Suzie gets the strangest feeling she’s being watched. Two days later, they hear that Eileen has been shot dead and her husband arrested.<br/>  <br/> Suzie is convinced there is more to this than meets the eye, and she and her family investigate. But the police seem uninterested in their findings, and Suzie soon begins to feel that someone is following her every move . . .<br/>  <br/> “Genealogy buffs will appreciate how the protagonist’s inherent curiosity about her past morphs into amateur detecting. Low-key, almost cozy, and great for readers who enjoy family ensemble casts.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fay Sampson
      </h2>
      
      <p class="authorDescription body article">Fay Sampson now lives in Devon, after many years abroad. As a keen genealogist, she has traced some of her ancestors to before the Norman Conquest, and is constantly adding to her tree.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e81ca302